/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./editSource.vue?vue&type=template&id=f8a47dae&scoped=true"
import script from "./editSource.vue?vue&type=script&lang=js"
export * from "./editSource.vue?vue&type=script&lang=js"
import style0 from "./editSource.vue?vue&type=style&index=0&id=f8a47dae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a47dae",
  null
  
)

export default component.exports